import api from './api';

/**
 * Get the member's nudge preferences.
 */
export const getNudgePreferences = async () => {
  const { data } = await api.get('/nudges/preferences');
  return data;
};

/**
 * Update nudge preferences.
 * Only include fields you want to change — all are optional.
 */
export const updateNudgePreferences = async (prefs) => {
  const { data } = await api.put('/nudges/preferences', prefs);
  return data;
};

/**
 * Snooze nudges until a given ISO timestamp.
 * Pass null to clear an existing snooze.
 * @param {string|null} snoozeUntil - ISO 8601 datetime string or null
 */
export const snoozeNudges = async (snoozeUntil) => {
  const { data } = await api.post('/nudges/snooze', { snooze_until: snoozeUntil });
  return data;
};

/**
 * Fetch nudge history (most recent first).
 * @param {number} limit - max results (1–100)
 */
export const getNudgeHistory = async (limit = 20) => {
  const { data } = await api.get('/nudges/history', { params: { limit } });
  return data;
};
